import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import EventBus from './EventBus'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { pt } from 'vuetify/locale'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { socketServiceInstance } from './services/socketService' // Importe o socketService

import '@fontsource/roboto/100.css'
import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
import '@fontsource/roboto/900.css'

import { aliases, md } from 'vuetify/iconsets/md'

const vuetify = createVuetify({
  locale: {
    locale: 'pt',
    messages: { pt }
  },
  theme: {
    defaultTheme: store.state.theme.theme,
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#008bd1ff',
          secondary: '#0e1f31',
          warning: '#FFC107',
          'on-warning': '#212121',
          info: '#2196F3', // A standard blue for info
          'on-info': '#FFFFFF', // White text on info background
          success: '#4CAF50', // A standard green for success
          'on-success': '#FFFFFF', // White text on success background
        }
      },
      dark: {
        dark: true,
        colors: {
          primary: '#2196F3', // Um azul para o tema escuro
          secondary: '#424242', // Um cinza escuro para o tema escuro
          warning: '#FFD54F',
          'on-warning': '#212121',
          info: '#64B5F6', // Lighter blue for dark theme info
          'on-info': '#212121', // Dark text on info background
          success: '#81C784', // Lighter green for dark theme success
          'on-success': '#212121', // Dark text on success background
        }
      }
    },
  },
  icons: {
    defaultSet: 'md',
    aliases,
    sets: {
      md,
    },
  },
  components,
  directives,
})

const allowedHostOrigins = (process.env.VUE_APP_HOST_ORIGINS || '')
  .split(',')
  .map((origin) => origin.trim())
  .filter(Boolean)

window.addEventListener('message', (event) => {
  if (allowedHostOrigins.length && !allowedHostOrigins.includes(event.origin)) {
    return
  }

  const message = event?.data
  if (!message || message.type !== 'SET_THEME') return

  const theme = message.theme
  if (theme === 'light' || theme === 'dark') {
    store.commit('theme/SET_THEME', theme)
  }
})

// Crie a app primeiro
const app = createApp(App)

// Agora configure as propriedades globais CORRETAMENTE
app.config.globalProperties.$socketService = socketServiceInstance
app.config.globalProperties.$eventBus = EventBus

// Use os plugins
app.use(store)
app.use(router)
app.use(vuetify)

// Monte a app
app.mount('#app')
